function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 23C5.9 23 1 18.1 1 12S5.9 1 12 1s11 4.9 11 11-4.9 11-11 11zm0-20c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 13c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1zM12 17c-.1 0-.3 0-.4-.1-.1 0-.2-.1-.3-.2-.2-.2-.3-.4-.3-.7 0-.1 0-.3.1-.4s.1-.2.2-.3.2-.2.3-.2c.2-.1.5-.1.8 0 .1 0 .2.1.3.2s.2.2.2.3.1.2.1.4c0 .3-.1.5-.3.7s-.4.3-.7.3z"
});

function SvgIconAlert(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0xMiAyM2MtNi4xIDAtMTEtNC45LTExLTExczQuOS0xMSAxMS0xMSAxMSA0LjkgMTEgMTEtNC45IDExLTExIDExem0wLTIwYy01IDAtOSA0LTkgOXM0IDkgOSA5IDktNCA5LTktNC05LTktOXoiLz48cGF0aCBkPSJtMTIgMTNjLS42IDAtMS0uNC0xLTF2LTRjMC0uNi40LTEgMS0xczEgLjQgMSAxdjRjMCAuNi0uNCAxLTEgMXoiLz48cGF0aCBkPSJtMTIgMTdjLS4xIDAtLjMgMC0uNC0uMS0uMSAwLS4yLS4xLS4zLS4yLS4yLS4yLS4zLS40LS4zLS43IDAtLjEgMC0uMy4xLS40cy4xLS4yLjItLjMuMi0uMi4zLS4yYy4yLS4xLjUtLjEuOCAwIC4xIDAgLjIuMS4zLjJzLjIuMi4yLjMuMS4yLjEuNGMwIC4zLS4xLjUtLjMuN3MtLjQuMy0uNy4zeiIvPjwvc3ZnPg==";
export { SvgIconAlert as ReactComponent };